import { useEffect, useState } from 'react'
import { BusinessConciergeService } from '.'
import { PopupAction } from '../../../common/popup/PopupAction'
import EventEmitter from '../../../helpers/EventEmitter'

export const SHOW_POPUP_BUSINESS_CONCIERGE = 'SHOW_POPUP_BUSINESS_CONCIERGE'

const PopupBusinessConcierge = () => {
  const [isShow, setIsShow] = useState(false)
  const [popUpTitle, setPopUpTitle] = useState('')

  const handleClose = () => {
    setIsShow(false)
  }

  useEffect(() => {
    const openPopup = (title) => {
      setIsShow(true)
      setPopUpTitle(title)
    }
    EventEmitter.subscribe(SHOW_POPUP_BUSINESS_CONCIERGE, openPopup)

    return () =>
      EventEmitter.unsubscribe(SHOW_POPUP_BUSINESS_CONCIERGE, openPopup)
  }, [])

  return (
    <PopupAction
      appendStyle={{
        width: 712,
        borderRadius: '4px',
        padding: '20px 20px 8px',
        backgroundColor: '#F3F3F3',
      }}
      title={popUpTitle}
      isShow={isShow}
      handleClose={handleClose}
    >
      <BusinessConciergeService setIsShow={setIsShow} />
    </PopupAction>
  )
}

export default PopupBusinessConcierge
